export const SUMMARY_ROW_SCROLL_THRESHOLD = 4;

const EMPTY_SCROLL_INDICATORS = {
  canScrollLeft: false,
  canScrollRight: false,
  maxScrollLeft: 0,
};

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const resolveSummaryRowScrollIndicators = ({
  scrollLeft,
  containerWidth,
  contentWidth,
  threshold = SUMMARY_ROW_SCROLL_THRESHOLD,
} = {}) => {
  const resolvedScrollLeft = toFiniteNumber(scrollLeft);
  const resolvedContainerWidth = toFiniteNumber(containerWidth);
  const resolvedContentWidth = toFiniteNumber(contentWidth);
  const resolvedThreshold = Math.max(0, toFiniteNumber(threshold) ?? 0);

  if (
    resolvedScrollLeft === null ||
    resolvedContainerWidth === null ||
    resolvedContentWidth === null ||
    resolvedContainerWidth <= 0 ||
    resolvedContentWidth <= 0
  ) {
    return EMPTY_SCROLL_INDICATORS;
  }

  const maxScrollLeft = Math.max(0, resolvedContentWidth - resolvedContainerWidth);
  if (maxScrollLeft <= 0) {
    return EMPTY_SCROLL_INDICATORS;
  }

  return {
    canScrollLeft: resolvedScrollLeft > resolvedThreshold,
    canScrollRight: resolvedScrollLeft < maxScrollLeft - resolvedThreshold,
    maxScrollLeft,
  };
};

export const resolveSummaryRowEdgeHoverLock = ({
  previousLock,
  hoveredScrollButton,
  canScrollLeft,
  canScrollRight,
} = {}) => {
  const safePreviousLock = {
    left: previousLock?.left === true,
    right: previousLock?.right === true,
  };

  return {
    left: canScrollLeft
      ? false
      : hoveredScrollButton === "left"
        ? true
        : safePreviousLock.left,
    right: canScrollRight
      ? false
      : hoveredScrollButton === "right"
        ? true
        : safePreviousLock.right,
  };
};
